var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('loading-component'):_c('Select',{attrs:{"filterable":""},model:{value:(_vm.buffer),callback:function ($$v) {_vm.buffer=$$v},expression:"buffer"}},_vm._l((_vm.sorted),function(property){return _c('Option',{key:property.attribute,attrs:{"value":property.attribute}},[_vm._v(_vm._s(property.label))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }